// services/lead-context.service.ts
import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LeadContextService {
  private cdSiglaTipoSubject = new BehaviorSubject<string | null>(null);
  cdSiglaTipo$ = this.cdSiglaTipoSubject.asObservable();

  hasNavigationBar: EventEmitter<boolean> = new EventEmitter(true);


  setCdSiglaTipo(tipo: string | null): void {
    this.cdSiglaTipoSubject.next(tipo);
  }

  getCdSiglaTipo(): string | null {
    return this.cdSiglaTipoSubject.value;
  }

  getBreadcrumbLabel(): string {
    const tipo = this.getCdSiglaTipo();
    if (!tipo) return 'Leads';

    const tipoUpper = tipo.toUpperCase();

    // Verificar se é PR (pode ser "PR" ou "CAPR000001" ou similar)
    if (tipoUpper === 'PR' || tipoUpper.startsWith('CAPR') || tipoUpper.includes('PR')) {
      return 'Período de Recompra';
    }

    if (tipoUpper === 'PA') {
      return 'Propostas aprovadas';
    }

    if (tipoUpper === 'SO') {
      return 'Simulações Online';
    }

    if (tipoUpper === 'SS') {
      return 'Sign&Drive';
    }

    if (tipoUpper === 'SP') {
      return 'Renovações';
    }

    return 'Leads';
  }
}

